import React from "react";

import { useTranslation } from "react-i18next";

import { observer } from "mobx-react";

export const BonusCardShopName = observer(function BonusCardShopName(props: {
	shopName: string | null;
}) {
	const { t } = useTranslation("my-bonuses");

	if (!props.shopName) {
		return null;
	}

	return (
		<span>
			{t("SHOP")}: {props.shopName}
		</span>
	);
});
